import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 384 512"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M172.287 65.071c-4.598 2.265-4.268-4.109-4.457 86.129l-.169 81.12H86.679c-89.369 0-83.571-.275-85.633 4.069-1.558 3.284-1.558 35.938 0 39.222 2.237 4.713-4.234 4.37 85.824 4.559l80.791.169.169 80.791c.189 90.058-.154 83.587 4.559 85.824 3.284 1.558 35.938 1.558 39.222 0 4.713-2.237 4.37 4.234 4.559-85.824l.169-80.791 80.791-.169c90.058-.189 83.587.154 85.824-4.559 1.558-3.284 1.558-35.938 0-39.222-2.062-4.344 3.736-4.069-85.633-4.069h-80.982l-.169-81.12c-.189-90.426.155-83.917-4.559-86.154-3.273-1.553-36.164-1.533-39.324.025"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "plus"}) } }